// controllers/send_controller.js
import { Controller } from "@hotwired/stimulus";
import toast from "../utils/toast";

export default class extends Controller {
  static targets = ["form", "amount", "email"];
  static values = { posturl: String, max: Number, amountLocked: Boolean };

  connect() {
    // If you want to set the action from data value, do it once here.
    if (this.hasPosturlValue && this.formTarget.action !== this.posturlValue) {
      this.formTarget.action = this.posturlValue;
    }

    this.loadSavedData();
  }

loadSavedData() {
  const savedAmount = sessionStorage.getItem("sendAmount");
  const savedEmail = sessionStorage.getItem("sendEmail");

  if (savedAmount && this.hasAmountTarget) {
    this.amountTarget.value = savedAmount;

    this.amountTarget.dataset.autofilled = "1";
    this.amountTarget.dataset.initialValue = savedAmount;
  }

  if (savedEmail && this.hasEmailTarget) {
    this.emailTarget.value = savedEmail;

    this.emailTarget.dataset.autofilled = "1";
    this.emailTarget.dataset.initialValue = savedEmail;
  }
}

  setSavedData() {
    sessionStorage.setItem("sendAmount", this.amountTarget?.value ?? "");
    sessionStorage.setItem("sendEmail", this.emailTarget?.value ?? "");
  }

  clearSavedData() {
    sessionStorage.removeItem("sendAmount");
    sessionStorage.removeItem("sendEmail");
  }

  // data-action="submit->send#submit" on the <form>
  submit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // 1) native form constraints first
    if (!this.formTarget.checkValidity()) {
      this.formTarget.reportValidity();
      return;
    }

    // If over max, cap and REQUIRE second submit
    if (this.hasAmountTarget && this.hasMaxValue) {
      const num = this.parseAmount(this.amountTarget.value ?? "");
      if (Number.isFinite(num) && num > this.maxValue) {
        e.preventDefault(); // stop this submit
        if (this.amountLockedValue) {
          toast("Insufficient funds", "error");
        } else {
          this.amountTarget.value = this.formatAmount(this.maxValue);
          this.amountTarget.focus();
          this.amountTarget.select?.();
        }
        return;             // user must press submit again
      }
    }

    // set ammount and email to the session storage
    this.setSavedData();

    this.formTarget.requestSubmit();
  };

  // Handle Turbo submit completion
  onSubmitEnd = (event) => {
  }

  // --- helpers ---
  parseAmount(v) {
    const cleaned = String(v).replace(/[^0-9.]/g, "");
    const [head, ...rest] = cleaned.split(".");
    const normalized = head + (rest.length ? "." + rest.join("") : "");
    const n = Number.parseFloat(normalized);
    return Number.isFinite(n) ? n : NaN;
  }

  formatAmount(n) {
    return (Math.round(n * 100) / 100).toFixed(2);
  }
}
